module.exports = ".Editable{border:1px dashed #009BE1;position:relative}\n"